import { type Node } from '@craftjs/core';
import { InspectorPageSettings } from '@/components/inspector/InspectorPageSettings/InspectorPageSettings';
import { isContainerNode, isPopupNode } from '@/utils/helperFunc';
import Page, { type PageProps } from '@builder4/shared/components/Page';

const EditorPage = (props: Partial<PageProps>) => {
  return <Page {...props}>{props.children}</Page>;
};

EditorPage.craft = {
  ...Page.craft,
  rules: {
    canDrag: () => false,
    canMoveIn: (nodes: Node[]) => nodes.every((node) => isContainerNode(node) || isPopupNode(node)),
  },
  related: {
    toolbar: InspectorPageSettings,
  },
};

export default EditorPage;
